/*******************************************************************
* PAGE        : CheckboxComponent
* REMARKS     : Comman Checkbox Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 13-01-2026
********************************************************************/

import { useEffect, useRef } from 'react';
import './CheckboxComponent.css';

const CheckboxComponent = ({
    label,
    checked,
    onChange,
    error,
    indeterminate = false,
    disabled = false,
    style = {},
    labelPosition = "end",
    ...props
}) => {

    const checkboxRef = useRef(null);

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);


    const handleChange = (e) => {
        onChange && onChange(e);
    };

    return (
        <div className="checkbox-container" style={style}>
            <div className="checkbox-wrapper">
                {label && labelPosition == "start" && <span className="checkbox-label-text checkbox-label-start">{label}</span>}
                <label className={`checkbox-label ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
                    <input
                        ref={checkboxRef}
                        type="checkbox"
                        checked={checked}
                        onChange={handleChange}
                        disabled={disabled}
                        className="checkbox-input"
                        {...props}
                    />
                    <span className="custom-checkbox-button"></span>
                    {label && labelPosition == "end" && <span className="checkbox-label-text checkbox-label-end">{label}</span>}
                </label>
            </div>
        </div>
    );
};

export default CheckboxComponent;
